var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZerion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 60,
    viewBox: "0 0 163 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.932 17C26.8767 17 24.3999 19.4768 24.3999 22.5321V36.7574C24.3999 39.8126 26.8767 42.2894 29.932 42.2894H44.1573C47.2125 42.2894 49.6893 39.8126 49.6893 36.7574V22.5321C49.6893 19.4768 47.2125 17 44.1573 17H29.932ZM40.4035 27.2738H37.0447L38.6253 24.9029H33.0932L31.0597 22.8694C30.9352 22.7449 31.0233 22.5321 31.1994 22.5321H42.7689C43.1858 22.5321 43.429 23.0025 43.188 23.3427L40.4035 27.2738ZM33.686 32.0156H37.0447L35.4641 34.3865H40.9962L43.0298 36.4201C43.1543 36.5445 43.0661 36.7574 42.8901 36.7574H31.3206C30.9037 36.7574 30.6604 36.2869 30.9014 35.9468L33.686 32.0156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.977 29.2496C123.977 32.9595 120.881 35.9671 117.062 35.9671C113.243 35.9671 110.147 32.9595 110.147 29.2496C110.147 25.5396 113.243 22.5321 117.062 22.5321C120.881 22.5321 123.977 25.5396 123.977 29.2496ZM120.816 29.2496C120.816 31.6501 119.135 33.5962 117.062 33.5962C114.989 33.5962 113.308 31.6501 113.308 29.2496C113.308 26.849 114.989 24.9029 117.062 24.9029C119.135 24.9029 120.816 26.849 120.816 29.2496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5074 22.7296H74.1885V23.1248L68.0637 33.3986H73.7933V35.5719H63.7171V35.1768L70.0394 24.9029H64.5074V22.7296Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5472 22.7296H86.0429V24.9029H80.5108V28.0641H84.8574V30.0399H80.5108V33.3986H86.2405V35.5719H77.5472V22.7296Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1313 22.7296H89.7968V35.5719H92.7604V30.6326H94.1434L97.107 35.5719H100.268L96.9094 30.0399C98.9642 29.5657 99.4779 27.4714 99.4779 26.4835C99.4779 23.4804 96.5801 22.7296 95.1313 22.7296ZM92.7604 28.6568V24.9029H94.7361C95.724 24.9029 96.7119 25.6142 96.7119 26.8787C96.7119 28.1432 95.5264 28.591 94.9337 28.6568H92.7604Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.627 22.7296H106.591V35.5719H103.627V22.7296Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.336 35.5719V22.7296H130.695L135.634 31.0277V22.7296H138.4V35.5719H135.436L129.904 26.4835V35.5719H127.336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZerion);
export default __webpack_public_path__ + "static/media/zerion.af141b65c1ef1d93c3b5cce48d7625e4.svg";
export { ForwardRef as ReactComponent };